import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 're-users-export-dialog',
    templateUrl: './users-export-dialog.component.html',
    styleUrls: ['./users-export-dialog.component.scss'],
    standalone: false
})
export class UsersExportDialogComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }
  filters: any = {};

  ngOnInit(): void {
  }


  accept() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
